import ActiveEntertainmentIcon from '@svg/active-entertainment.svg';
import ArtIcon from '@svg/art.svg';
import CameraIcon from '@svg/camera.svg';
import ComedyMaskIcon from '@svg/comedy-mask.svg';
import CultureIcon from '@svg/culture.svg';
import DanceIcon from '@svg/dance.svg';
import EatDrinksIcon from '@svg/eat-drinks.svg';
import EventsTipsIcon from '@svg/events-tips.svg';
import GamingIcon from '@svg/gaming.svg';
import HeritageIcon from '@svg/heritage.svg';
import IceSkatingIcon from '@svg/ice-skating.svg';
import InfoIcon from '@svg/info.svg';
import KidsIcon from '@svg/kids.svg';
import MusicIcon from '@svg/music.svg';
import NassauSpotsIcon from '@svg/nassau-spots.svg';
import NatureIcon from '@svg/nature.svg';
import PointerIcon from '@svg/pointer.svg';
import ShoppingIcon from '@svg/shopping.svg';
import SparkleReversedIcon from '@svg/sparkle-reversed.svg';
import TheaterIcon from '@svg/theater.svg';
import VideoIcon from '@svg/video.svg';
import {
  Accessibility,
  AccessibilitySign,
  AfricanTree,
  Airplane,
  AppleHalf,
  Bank,
  Basketball,
  Bed,
  Bicycle,
  BinMinusIn,
  Bonfire,
  Bookmark,
  BookmarkSolid,
  Calendar,
  CardWallet,
  Cart,
  Cash,
  Check,
  ChurchSide,
  CinemaOld,
  ClosedCaptionsTag,
  CloudDownload,
  CoffeeCup,
  Community,
  CreditCard,
  CurveArray,
  Cutlery,
  DesignPencil,
  Download,
  EmojiBlinkLeft,
  Euro,
  EuroSquare,
  Eye,
  EyeClosed,
  FacebookTag,
  Farm,
  Filter,
  Fish,
  Flower,
  Gamepad,
  Google,
  GraduationCap,
  Group,
  Gym,
  Heart,
  HeartSolid,
  HomeAlt,
  IceCream,
  InfoCircle,
  InfoCircleSolid,
  Instagram,
  Language,
  Leaf,
  Learning,
  Link,
  Linkedin,
  MailOut,
  Map,
  MapPin,
  MediaImage,
  Menu,
  Minus,
  MoneySquare,
  MusicDoubleNote,
  MusicNote,
  NavArrowDown,
  NavArrowLeft,
  NavArrowRight,
  NavArrowUp,
  Neighbourhood,
  PageFlip,
  Palette,
  Parking,
  PauseSolid,
  Phone,
  Pinterest,
  PizzaSlice,
  Play,
  Plus,
  Rain,
  Restart,
  RssFeed,
  Search,
  SeaWaves,
  SendDiagonal,
  SendMail,
  ShareIos,
  Shirt,
  ShoppingBag,
  Skateboarding,
  SortDown,
  SoundHigh,
  SoundOff,
  Sparks,
  Star,
  SunLight,
  Swimming,
  Telegram,
  Tiktok,
  Train,
  Tree,
  Twitter,
  Upload,
  UserCart,
  Walking,
  Wallet,
  WarningCircle,
  WhiteFlag,
  Wolf,
  Xmark,
  Yoga,
  Youtube,
} from 'iconoir-react';

const icons = {
  ACCESSIBILITY_SIGN: AccessibilitySign,
  ACTIVE_ENTERTAINMENT: ActiveEntertainmentIcon,
  ACCESSIBILITY: Accessibility,
  AFRICAN_TREE: AfricanTree,
  AIRPLANE: Airplane,
  APPLE_HALF: AppleHalf,
  ART: ArtIcon,
  BANK: Bank,
  BASKETBALL: Basketball,
  BED: Bed,
  BICYCLE: Bicycle,
  BIN_MINUS_IN: BinMinusIn,
  BONFIRE: Bonfire,
  BOOKMARK_SOLID: BookmarkSolid,
  BOOKMARK: Bookmark,
  CALENDAR: Calendar,
  CAMERA: CameraIcon,
  CARD_WALLET: CardWallet,
  CART: Cart,
  CASH: Cash,
  CHECK: Check,
  CHURCH_SIDE: ChurchSide,
  CINEMA_OLD: CinemaOld,
  CLOSED_CAPTIONS_TAG: ClosedCaptionsTag,
  CLOUD_DOWNLOAD: CloudDownload,
  COFFEE_CUP: CoffeeCup,
  COMEDY_MASK: ComedyMaskIcon,
  COMMUNITY: Community,
  CREDIT_CARD: CreditCard,
  CULTURE: CultureIcon,
  CURVE_ARRAY: CurveArray,
  CUTLERY: Cutlery,
  DANCE: DanceIcon,
  DESIGN_PENCIL: DesignPencil,
  DOWNLOAD: Download,
  EAT_DRINKS: EatDrinksIcon,
  EMOJI_BLINK_LEFT: EmojiBlinkLeft,
  EURO_SQUARE: EuroSquare,
  EURO: Euro,
  EVENTS_TIPS: EventsTipsIcon,
  EYE_CLOSED: EyeClosed,
  EYE: Eye,
  FACEBOOK_TAG: FacebookTag,
  FACEBOOK: FacebookTag,
  FARM: Farm,
  FILTER: Filter,
  FISH: Fish,
  FLOWER: Flower,
  GAMEPAD: Gamepad,
  GAMING: GamingIcon,
  GOOGLE: Google,
  GRADUATION_CAP: GraduationCap,
  GROUP: Group,
  GYM: Gym,
  HEART_SOLID: HeartSolid,
  HEART: Heart,
  HERITAGE: HeritageIcon,
  HOME_ALT: HomeAlt,
  ICE_CREAM: IceCream,
  ICESKATING: IceSkatingIcon,
  INFO_CIRCLE_SOLID: InfoCircleSolid,
  INFO_CIRCLE: InfoCircle,
  INFO: InfoIcon,
  INSTAGRAM: Instagram,
  KIDS: KidsIcon,
  LANGUAGE: Language,
  LEAF: Leaf,
  LEARNING: Learning,
  LINK: Link,
  LINKEDIN: Linkedin,
  MAIL_OUT: MailOut,
  MAP_PIN: MapPin,
  MAP: Map,
  MEDIA_IMAGE: MediaImage,
  MENU: Menu,
  MINUS: Minus,
  MONEY_SQUARE: MoneySquare,
  MUSIC_DOUBLE_NOTE: MusicDoubleNote,
  MUSIC_NOTE: MusicNote,
  MUSIC: MusicIcon,
  NASSAU_SPOTS: NassauSpotsIcon,
  NATURE: NatureIcon,
  NAV_ARROW_DOWN: NavArrowDown,
  NAV_ARROW_LEFT: NavArrowLeft,
  NAV_ARROW_RIGHT: NavArrowRight,
  NAV_ARROW_UP: NavArrowUp,
  NEIGHBOURHOOD: Neighbourhood,
  PAGE_FLIP: PageFlip,
  PALETTE: Palette,
  PARKING: Parking,
  PAUSE_SOLID: PauseSolid,
  PHONE: Phone,
  PINTEREST: Pinterest,
  PIZZA_SLICE: PizzaSlice,
  PLAY: Play,
  PLUS: Plus,
  POINTER: PointerIcon,
  RAIN: Rain,
  RESTART: Restart,
  RSS_FEED: RssFeed,
  SEA_WAVES: SeaWaves,
  SEARCH: Search,
  SEND_DIAGONAL: SendDiagonal,
  SEND_MAIL: SendMail,
  SHARE_IOS: ShareIos,
  SHIRT: Shirt,
  SHOPPING_BAG: ShoppingBag,
  SHOPPING: ShoppingIcon,
  SKATEBOARDING: Skateboarding,
  SORT_DOWN: SortDown,
  SOUND_HIGH: SoundHigh,
  SOUND_OFF: SoundOff,
  SPARKLE_REVERSED: SparkleReversedIcon,
  SPARKS: Sparks,
  STAR: Star,
  SUN_LIGHT: SunLight,
  SWIMMING: Swimming,
  TELEGRAM: Telegram,
  THEATER: TheaterIcon,
  TIKTOK: Tiktok,
  TRAIN: Train,
  TREE: Tree,
  TWITTER: Twitter,
  UPLOAD: Upload,
  USER_CART: UserCart,
  VIDEO: VideoIcon,
  WALKING: Walking,
  WALLET: Wallet,
  WARNING_CIRCLE: WarningCircle,
  WHITE_FLAG: WhiteFlag,
  WOLF: Wolf,
  XMARK: Xmark,
  YOGA: Yoga,
  YOUTUBE: Youtube,
};

export type IconType = keyof typeof icons;

export interface Props {
  icon: IconType;
  className?: string;
  strokeWidth?: number;
}

export default function Icon({ icon, className, strokeWidth = 2 }: Props) {
  const IconElement =
    // @ts-expect-error - Replaced icon component with list input. This supports old icon selections in prepr.
    icons[icon] || icons[icon.toUpperCase().replaceAll('-', '_')];

  if (!IconElement) {
    console.warn(`Icon ${icon} not found`);

    return null;
  }

  return <IconElement strokeWidth={strokeWidth} className={className} />;
}
